import { pick, omit } from 'lodash';
import { css } from 'styled-components';
import { style } from 'styled-system';

import { USER_ROLES } from 'src/constants';
import { freelancerTheme, candidateTheme, employerTheme } from 'src/theme';

export const overflowX = style({ prop: 'overflowX', cssProperty: 'overflowX' });
export const overflowY = style({ prop: 'overflowY', cssProperty: 'overflowY' });
export const whiteSpace = style({ prop: 'whiteSpace', cssProperty: 'whiteSpace' });
export const objectFit = style({ prop: 'objectFit', cssProperty: 'objectFit' });
export const filter = style({ prop: 'filter', cssProperty: 'filter' });

export const rowGap = style({ prop: 'rowGap', cssProperty: 'marginTop' });
export const columnGap = style({ prop: 'columnGap', cssProperty: 'marginLeft' });
export const gaps = css`
  > *:not(:first-child) {
    ${rowGap};
    ${columnGap};
  }
`;

const marginProps = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my'];
const paddingProps = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py'];
const spaceProps = [...marginProps, ...paddingProps];
const layoutProps = ['display', 'width', 'height', 'maxWidth', 'maxHeight', 'minWidth', 'minHeight', 'verticalAlign'];
const typographyProps = [
  'color',
  'colors',
  'bg',
  'fontFamily',
  'fontSize',
  'fontWeight',
  'lineHeight',
  'textAlign',
  'letterSpacing',
  'textTransform',
  'whiteSpace'
];
const flexboxProps = [
  'alignItems',
  'alignContent',
  'justifyContent',
  'justifyItems',
  'flexWrap',
  'flexBasis',
  'flexDirection',
  'flex',
  'justifySelf',
  'alignSelf',
  'order'
];
const backgroundsProps = [
  'background',
  'backgroundColor',
  'backgroundImage',
  'backgroundSize',
  'backgroundPosition',
  'backgroundRepeat'
];
const positioningProps = ['position', 'zIndex', 'top', 'right', 'bottom', 'left'];
const borderProps = [
  'border',
  'borderTop',
  'borderTopColor',
  'borderRight',
  'borderRightColor',
  'borderBottom',
  'borderBottomColor',
  'borderLeft',
  'borderLeftColor',
  'borderColor',
  'borderWidth',
  'borderStyle',
  'borderRadius',
  'boxShadow  '
];
export const generalProps = ['opacity', 'overflow', 'overflowX', 'overflowY', 'transition'];

export const imageProps = ['objectFit'];

export const styledSystemProps = [
  ...spaceProps,
  ...layoutProps,
  ...typographyProps,
  ...flexboxProps,
  ...backgroundsProps,
  ...positioningProps,
  ...borderProps,
  ...generalProps,
  ...imageProps
];

export const getStyledSystemProps = props => [pick(props, styledSystemProps), omit(props, styledSystemProps)];

export const getLayoutProps = props => {
  const lProps = [...spaceProps, ...layoutProps, ...flexboxProps];
  const [layoutSystemProps, restProps] = [pick(props, lProps), omit(props, lProps)];
  return [layoutSystemProps, ...getStyledSystemProps(restProps)];
};

export const getThemeByUserRole = role => themesByUserRoles[role];

const themesByUserRoles = {
  [USER_ROLES.employer]: employerTheme,
  [USER_ROLES.freelancer]: freelancerTheme,
  [USER_ROLES.candidate]: candidateTheme,
  [USER_ROLES.university]: freelancerTheme
};
